import Request from './RequestHandler.js'

export default {
  offers (params) {
    return Request.make('get', 'reports/offers', params)
  },
  sets (params) {
    return Request.make('get', 'reports/sets', params)
  }
}
